const loginModule = {
  namespaced: true,
  state: {
    loginDto: undefined,
    twoFactorType: null,
  },
  getters: {
  },
  mutations: {
    setLoginDto (state, payload) {
      state.loginDto = payload
    },
    setTwoFactorType (state, payload) {
      state.twoFactorType = payload
    }
  },
  actions: {},
}

export default loginModule
